// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_layout__m8Vdf {
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;
  min-height: 100svh;
}

.Layout_layout__dashboard-main__S1tku {
  width: 100%;
  padding: 3rem 4rem 0;
  min-height: 120rem;
}

.Layout_layout__dashboard-content__zOGrI {
  max-width: 160rem;
  margin-inline: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB","sourcesContent":[".layout {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  min-height: 100vh;\n  min-height: 100svh;\n}\n\n.layout__dashboard-main {\n  width: 100%;\n  padding: 3rem 4rem 0;\n  min-height: 120rem;\n}\n\n.layout__dashboard-content {\n  max-width: 160rem;\n  margin-inline: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `Layout_layout__m8Vdf`,
	"layout__dashboard-main": `Layout_layout__dashboard-main__S1tku`,
	"layout__dashboard-content": `Layout_layout__dashboard-content__zOGrI`
};
export default ___CSS_LOADER_EXPORT___;
